import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class FileService {
  static ENDPOINT = `${BASE}/file`;

  static async uploadTermsFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    return await request({
      url: `${this.ENDPOINT}/terms`,
      method: 'POST',
      body: formData
    })
  }

  static async getTermsFile() {
    return await request({
      url: `${this.ENDPOINT}/terms`,
      headers: {'Accept': 'application/pdf'},
      responseType: 'blob'
    })
  }

  static async uploadBadge(id, file) {
    const formData = new FormData();
    formData.append('file', file);
    return await request({
      url: `${this.ENDPOINT}/badge/${encodeURIComponent(id)}`,
      method: 'POST',
      body: formData
    })
  }

  static async getBadge(id) {
    return await request({
      url: `${this.ENDPOINT}/badge/${encodeURIComponent(id)}`,
      headers: {'Accept': 'image/png'},
      responseType: 'blob'
    })
  }
}

export default FileService;
